import removeFromObjWhen from './removeWhen';

const removeUndefinedEntries = <T extends object>(values: T) =>
    removeFromObjWhen(values, val => typeof val === 'undefined');

export default removeUndefinedEntries;
